<gtd-widgets-info-layout [isLoading]="isLoading" (onRefresh)="getData()">
  <p500-ui-cube-preloader *ngIf="isLoading"></p500-ui-cube-preloader>
  <div class="c-widget--info c-widget--info--white" *ngIf="!isLoading" [ngClass]="customClass">
    <ul>
      <li class="title">Incident Info</li>
      <li>
        <p>
          <span class="key">Severity:</span>
          <span class="value">
            <gtd-ui-field-special-incident-status [data]="data.incident.severity"> </gtd-ui-field-special-incident-status>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Status:</span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.incident.status"> </gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Group:</span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.incident.group"> </gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Incident Message:</span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.incident.message"> </gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Related Type:</span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty [data]="data.incident.related_type">
            </gtd-ui-field-default-string-whitespace-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Related ID:</span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.incident.related_id"> </gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
    </ul>

    <ul>
      <li class="title">Resolution</li>
      <li>
        <p>
          <span class="key">Resolved By:</span>
          <span class="value">
            <ng-container *ngIf="data.incident.user.first_name && data.incident.user.last_name">
              <gtd-ui-field-default-string-or-empty [data]="data.incident.user.first_name + ' ' + data.incident.user.last_name">
              </gtd-ui-field-default-string-or-empty>
            </ng-container>
            <ng-container *ngIf="!data.incident.user.first_name || !data.incident.user.last_name">
              <gtd-ui-field-default-string-or-empty [data]="data.incident.user.first_name"> </gtd-ui-field-default-string-or-empty>
            </ng-container>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Resolution Message:</span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty [data]="data.incident.resolution_message">
            </gtd-ui-field-default-string-whitespace-or-empty>
          </span>
        </p>
      </li>
    </ul>

    <ul>
      <li class="title">Timestamps</li>
      <li>
        <p>
          <span class="key">Created At:</span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.incident.created_at * 1000"> </gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Resolved At:</span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.incident.resolved_at * 1000"> </gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
    </ul>
  </div>
</gtd-widgets-info-layout>
